<template>
  <div v-if="institutions.length > 1">
    <div class="tiered-ac">
      <span>Cambiar institución</span>
    </div>
      <TieredMenu :model="institutionsItems"/>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CredentialsServices from "@/services/Credentials.service.js";
export default {
  data() {
    return {
      credentialService: new CredentialsServices(),
    };
  },
  computed: {
    ...mapState(["institutions"]),
    institutionSelected: {
      get() {
        return this.$store.state.institution;
      },
      set(val) {
        this.setCurrentInstituion(val);
      }
    },
    institutionsItems: function () {
      return [{
        label: `${this.institutionSelected.institution_name}`,
        icon: 'pi pi-fw pi-home',
        items: this.institutions.map((i) => {
          return {
            label: i.institution_name,
            icon: 'pi pi-fw pi-home',
            command: () => this.setCurrentInstituion(i)
          }
        })
      }];
    }
  },
  methods: {
    toggle(event) {
      this.$refs.menu.toggle(event);
    },
    setCurrentInstituion(institution) {
      this.credentialService.setInstitution(institution);
      this.$router.push('/');
      window.location.reload();
    }
  }
};
</script>

<style>
  .tiered-ac {
    background-color: #efefef;
    padding-top: 7px;
    padding-bottom: 7px
  }
  .p-tieredmenu .p-menuitem-link:not(.p-disabled):hover {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
  }
  .p-tieredmenu .p-menuitem-active > .p-submenu-list  {
    display: block;
    left: -100% !important; 
    right: 100% !important; 
    top: 0;
  }
  .p-tieredmenu .p-menuitem-link:not(.p-disabled):hover .p-menuitem-text {
    color: rgba(0,0,0,0.87);
    text-align: center;
  }
  .p-tieredmenu .p-menuitem-link .p-menuitem-text {
    color: rgba(0,0,0,0.87);   
    text-align: center;
 }
 .p-tieredmenu .p-menuitem-link:not(.p-disabled):hover .p-submenu-icon {
    color: rgba(0,0,0,0.87);   

  }
  .p-tieredmenu .p-menuitem-link .p-submenu-icon {
    margin-left: 0px !important; 
  }
  .p-tieredmenu .p-menuitem-link {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
  }
  .p-tieredmenu .p-menuitem-link:not(.p-disabled):hover .p-submenu-icon {
    color: rgba(0,0,0,0.87);   
 
    transform: rotate(0.5turn);
  }
  .p-tieredmenu .p-menuitem-link .p-submenu-icon {
    transform: rotate(0.5turn);
  }
</style>



// WEBPACK FOOTER //
// src/components/core/Toolbar/InstitutionSelect.vue